import { IArtistAlbums } from '#/types/API/artists';
import withMatcher from '#/utils/withMatcher';

export const createActionArtistAppearsOnSetApearsOn = withMatcher(
  (payload: IArtistAlbums) => {
    return {
      type: 'artist_appears_on/set_appears_on',
      payload,
    };
  }
);

export const createActionArtistAppearsOnStartLoading = withMatcher(() => {
  return {
    type: 'artist_appears_on/start_loading',
  };
});

export const createActionArtistAppearsOnStopLoading = withMatcher(() => {
  return {
    type: 'artist_appears_on/stop_loading',
  };
});

export const createActionArtistAppearsOnError = withMatcher(() => {
  return {
    type: 'artist_appears_on/error_details',
  };
});

export const createActionArtistAppearsOnReset = withMatcher(() => {
  return {
    type: 'artist_appears_on/reset',
  };
});
